import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetOrgQuery } from "../../store/api/orgApi";
import { OrgDetailForm } from "./detailForm";
import { Org } from "../../schema/types/org/entity";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org";
export const OrgDetailInitializer: React.FC = () => {
  const { org: orgName } = useParams<RouteParams>();

  const { data: org, isLoading, isFetching, isError, error, refetch } = useGetOrgQuery(orgName, {
    skip: !orgName,
    refetchOnMountOrArgChange: true,
  });

  if (!org && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="org" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !org) {
    return <IncorrectItem kind="org" canCreate={false} />;
  }

  return <OrgDetailForm org={org as Org} />;
};
